import { render, staticRenderFns } from "./BotaoUpload.vue?vue&type=template&id=e596bd9e&"
import script from "./BotaoUpload.vue?vue&type=script&lang=js&"
export * from "./BotaoUpload.vue?vue&type=script&lang=js&"
import style0 from "./BotaoUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports